import { trans } from "@mongez/localization";
import { InputRule, requiredRule } from "@mongez/react-form";
import { BaseInput, BaseInputProps } from "./BaseInput";

export const phoneNumberRule: InputRule = {
  requiresValue: true,
  validate: ({ value }) => {
    const regex = /^01[0-2|5]{1}[0-9]{8}$/;

    if (!regex.test(value)) {
      return trans("invalidPhoneNumber");
    }
  },
};

export function PhoneNumberInput(props: BaseInputProps) {
  return <BaseInput rules={[requiredRule, phoneNumberRule]} {...props} />;
}
